import React from "react";
import "./Topbar.css";
import PhoneIcon from "../../assets/icons/phone.svg";
import EnvelopeIcon from "../../assets/icons/envelope.svg";
import TwitterIcon from "../../assets/icons/twitter.svg";
import InstagramIcon from "../../assets/icons/instagram.svg";
import LinkedinIcon from "../../assets/icons/linkedin.svg";
const Topbar = () => {
  return (
    <div className="topbar__component">
      <div className="topbar__component_left"></div>
      <div className="topbar__component_right">
        {/* <div className="topbar__compright_bgimg">
          <img src={BGImage} />
        </div> */}
        <div className="topbar__compright_content">
          <div className="topbar__compright_cntitem">
            <img src={PhoneIcon} className="topbar__compright_cntitemicn" />
            <div className="topbar__compright_cntitemtxtbox">
              <div className="topbar__compright_cntitemtxt">+262-735-8874 </div>
              <div className="topbar__compright_cntitemtxt">+262-735-8874 </div>
            </div>
          </div>
          <div className="topbar__compright_cntitem">
            <img src={EnvelopeIcon} className="topbar__compright_cntitemicn" />
            <div className="topbar__compright_cntitemtxtbox">
              <div className="topbar__compright_cntitemtxt">
                info@serenetax.com
              </div>
              <div className="topbar__compright_cntitemtxt">
                contact@serenetax.com{" "}
              </div>
            </div>
          </div>
          <div className="topbar__compright_cntitem">
            <img src={EnvelopeIcon} className="topbar__compright_cntitemicn" />
            <div className="topbar__compright_cntitemtxtbox">
              <div className="topbar__compright_cntitemtxt">Mon-Fri</div>
              <div className="topbar__compright_cntitemtxt">
                7:30 am - 11:30 pm (EST){" "}
              </div>
            </div>
          </div>
          <div className="topbar__compright_cnticns">
            <img src={TwitterIcon} className="topbar__compright_cnticn" />
            <img src={InstagramIcon} className="topbar__compright_cnticn" />
            <img src={LinkedinIcon} className="topbar__compright_cnticn" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
